<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <h3>{{ issue.name }}</h3>
      <v-divider />
    </v-col>
    <v-col cols="12">
      <v-row align="center" class="ma-0">
        <!--<div v-html="messages.preview"/>-->
        <v-card
          class="iframe-preview"
          v-for="(message, i) in messages"
          :key="i"
        >
          <div class="iframe-preview__header pa-1">
            <div class="d-flex justify-space-between">
              <div class="iframe-preview__header-title">
                <img
                  src="@/assets/of-logo.png"
                  width="25px"
                  height="25px"
                />
                <div class="ml-1">
                  <span class="indigo--text font-weight-bold">Outfox AI</span>
                  <br/>
                  <span class="font-weight-thin">Sponsored
                    <span>&middot</span>
                    <span class="mdi mdi-earth"></span>
                  </span>
                </div>
              </div>
              <v-menu bottom left>
                <v-btn
                  slot="activator"
                  icon
                  small
                  class="ma-0 pa-0"
                >
                  <v-icon class="subtitle-2">more_vert</v-icon>
                </v-btn>

                <v-list>
                  <!--<v-list-tile-->
                  <!--v-ripple-->
                  <!--class="pointer"-->
                  <!--&gt;-->
                  <!--<v-list-tile-title>Edit</v-list-tile-title>-->
                  <!--</v-list-tile>-->
                  <v-list-item
                    v-ripple
                    class="pointer"
                  >
                    <v-list-item-title @click="copyMessage(message)">Copy</v-list-item-title>
                  </v-list-item>
                  <!--<v-list-tile-->
                  <!--v-ripple-->
                  <!--class="pointer"-->
                  <!--&gt;-->
                  <!--<v-list-tile-title>Delete</v-list-tile-title>-->
                  <!--</v-list-tile>-->
                </v-list>
              </v-menu>
            </div>
            <span>
              {{ message.text }}
            </span>
          </div>
          <div class="iframe-preview__image">
            <img
              v-if="message.selectedVideo"
              :src="message.selectedVideo.picture"
              width="100%"
              height="100%"
            />
            <img
              v-else-if="message.reviewFileUrl"
              :src="message.reviewFileUrl"
              width="100%"
              height="100%"
            />
            <img
              v-else-if="message.externalUrl"
              :src="message.externalUrl"
              width="100%"
              height="100%"
            />
            <img
              v-else
              src="@/assets/of-logo.png"
              width="100%"
              height="100%"
            />
          </div>
          <div class="iframe-preview__body pa-1">
            <div class="d-flex align-center justify-space-between">
              <div class="text">
                <span class="text-uppercase">{{ message.link }}</span>
                <span class="font-weight-bold">{{ message.headline }}</span>
                <span>{{ message.description }}</span>
              </div>
              <div class="button">{{ message.callToAction}}</div>
            </div>
          </div>
          <div class="iframe-preview__footer pa-1">
            <div class="d-flex justify-space-around align-center">
              <span class="grey--text text--darken-2">
                <span class="mdi mdi-thumb-up"></span>
                Like
              </span>
              <span class="grey--text text--darken-2">
                <span class="mdi mdi-comment-outline"></span>
                Comment
              </span>
              <span class="grey--text text--darken-2">
                <span class="mdi mdi-share"></span>
                Share
              </span>
            </div>
          </div>
        </v-card>
        <v-btn
          text
          color="primary"
          class="btn-dotted"
          @click="openDialog"
        >
          <v-icon>
            add
          </v-icon>
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import lodash from 'lodash'
  export default {
    name: 'messages-overview-campaign-block',
    data () {
      return {}
    },
    props: {
      issue: {
        type: Object,
        default: () => {}
      },
      messages: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      openDialog () {
        this.$emit('openDialog', this.issue)
      },
      copyMessage (message) {
        const copy = lodash.cloneDeep(message)
        this.$emit('copyMessage', copy)
      },
      editMessage (message) {
        this.$emit('editMessage', message)
      }
    }
  }
</script>
<style lang="scss">
  .iframe-preview {
    width: 150px;
    height: auto;
    margin: 0 8px 8px 0;
    border-radius: 3px;
    word-break: break-all;
    font-size: 8px;
    &__header {
      img, div {
        flex: none!important;
      }
      &-title {
        display: flex;
        align-items: center;
      }
    }

    &__body {
      word-break: break-all;
      background: #f5f5f5;
      border-top: 1px solid #e9e9e9;
      border-bottom: 1px solid #e9e9e9;
      .button {
        margin-left: 2px;
        padding: 2px;
        border: 1px solid #ccc;
        min-width: 50px;
        text-align: center;
        border-radius: 2px;
        font-size: 7px;
      }
    }
  }
  .btn-dotted {
    width: 68px!important;
    height: 68px!important;
    border: 2px dashed #5baae1;
    border-radius: 8px;
  }

</style>
